import React, { Component } from "react";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import OrdersSearch from "../components/search/searchWrapper/orders/OrdersSearch";
import { withTranslation } from "react-i18next";
import Footer from "../shared/Footer/Footer";
import Crc from "./pure/Crc";
import withIdleTimer from "../common/WithIdleTimer";
import { Route, Router } from "react-router-dom";
import ErrorScreen from "../errors/ErrorScreen";
import SearchWrapper from "../components/search/searchWrapper/SearchWrapper";
import DealerSearch from "../components/search/searchWrapper/dealer/DealerSearch";

class CRCApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      padding: "70px",
      renderApp: false,
    };
    this.currentCrc = new Crc(
      this.props.token,
      this.props.userDetails,
      this.props.history
    );
  }

  componentDidMount() {
    this.props.i18n.changeLanguage("en");
    this.setState({ renderApp: true });
  }

  setPadding = (padding) => {
    if (padding > 70) {
      this.setState({ padding: padding + "px" });
    }
  };

  render() {
    return (
      this.state.renderApp && (
        <Router history={this.props.history}>
          <div className="appWrapper">
            <div style={{ paddingTop: this.state.padding }}>
              <GlobalNavBar
                {...this.props}
                urlPath={window.location.pathname}
                setPadding={this.setPadding}
                user={this.currentCrc}
              />
            </div>
            <Route
              exact
              path="/(|search)"
              component={withIdleTimer(() => (
                <SearchWrapper {...this.props} user={this.currentCrc} />
              ))}
            />
            <Route
              exact
              path="/search/orders"
              component={withIdleTimer(() => (
                <OrdersSearch
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.currentCrc}
                />
              ))}
            />
            <Route
              exact
              path="/search/dealer"
              component={withIdleTimer(() => (
                <DealerSearch
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.currentCrc}
                />
              ))}
            />
            <Route
              exact
              path="/error"
              render={(props) => <ErrorScreen {...props} />}
            />
            <Footer
              isDealer={false}
              fromNscDealerSearch={this.props.fromNscDealerSearch}
              user={this.currentCrc}
              footerTitle={this.props.t("Footer.baseTitle")}
              helpSupportTitle={this.props.t("Footer.help")}
              permissions={this.props.userDetails.permissions}
            />
          </div>
        </Router>
      )
    );
  }
}

export default withTranslation("emp")(CRCApp);
